/**
 * Module-level cache for HotelBookingModal's embed bundle fetch, mirroring form-prefetch.ts's
 * formCache — reopening the same hotel-booking modal within one page visit (e.g. the attendee
 * closes it to check something on the page, then reopens) reuses the in-flight/resolved fetch
 * instead of paying another full round trip.
 */

import { getHotelBookingEmbedBundle, type HotelBookingEmbedBundle } from "./actions/hotel-booking-embed-actions";

const bundleCache = new Map<string, Promise<HotelBookingEmbedBundle | null>>();

const cacheKey = (eventId: number, bookingLinkId: number): string => `${eventId}:${bookingLinkId}`;

/**
 * Fetches the embed bundle, reusing an in-flight or already-resolved fetch for the same
 * (eventId, bookingLinkId) pair within this page session.
 */
export function getCachedHotelBookingEmbedBundle(
  eventId: number,
  bookingLinkId: number
): Promise<HotelBookingEmbedBundle | null> {
  const key = cacheKey(eventId, bookingLinkId);
  let entry = bundleCache.get(key);
  if (!entry) {
    entry = getHotelBookingEmbedBundle(eventId, bookingLinkId);
    bundleCache.set(key, entry);
  }
  return entry;
}

/**
 * Drops the cached bundle so the next open re-fetches — call after a successful booking submit,
 * since the cached `existingResponse` is now stale.
 */
export function invalidateHotelBookingEmbedBundleCache(eventId: number, bookingLinkId: number): void {
  bundleCache.delete(cacheKey(eventId, bookingLinkId));
}
